import Typegraphy from "@insite/mobius/Typography";
import React from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import translate from "@insite/client-framework/Translate";
import Zone from "@insite/client-framework/Components/Zone";
import { css } from "styled-components";

const enum fields  {
    modalTitle = "modalTitle"
}

interface Props extends WidgetProps{
    fields: {
        [fields.modalTitle]: String;
    }
}

const styles = {
    gridItem: {
        css: css`
            padding: 0;
            min-width: 100%;
        `
    }

}
const PopupWidget: React.FC<Props> = ({fields, id}) => {
    const [isModalOpen, setIsModalOpen] = React.useState(true);

    const modalCloseHandler = () => setIsModalOpen(false);

    return (
        <Modal
        headline={translate(`${fields.modalTitle}`)}
        contentLabel={'test'}
        isOpen={isModalOpen}
        handleClose={modalCloseHandler}
    >
        <GridContainer>
            <GridItem {...styles.gridItem} >
                <Zone contentId={id} zoneName="Content"></Zone>
            </GridItem>
        </GridContainer>
    </Modal>
        
    )
 }

 const definition: WidgetDefinition = {
    group: "Testing",
    fieldDefinitions: [
        {
            name: fields.modalTitle,
            displayName: "Modal Title",
            editorTemplate: "TextField",
            fieldType: "General",
            tooltip: "title tip",
            defaultValue: '',
            placeholder: "text placeholder",
            isRequired: true,
        }
    ]
}

//The widgetmodule define:
// -The component used the render the widget
// -How the widget should apper in the CMS
// -How the widget is editable in the cms
// -many other things 
const widgetModule: WidgetModule = {
    component: PopupWidget,
    definition
}


export default widgetModule;